export const EffectChoiceKey = {
  None: 'None',
  DesignerEffects: 'DesignerEffects',
  BackgroundBlur: 'BackgroundBlur',
  BackgroundSolidColor: 'BackgroundSolidColor',
};

export const EffectChoiceOrder = {
  [EffectChoiceKey.None]: 0,
  [EffectChoiceKey.DesignerEffects]: 1,
  [EffectChoiceKey.BackgroundBlur]: 2,
  [EffectChoiceKey.BackgroundSolidColor]: 3,
};

export const MTSmartEffect = {
  Blur: 'bg_blur',
  BackgroundColorSwap: 'bg_color',
  SmartCrop: 'smart_crop',
  DesignerEffects: 'design_ideas',
};

export const EffectChoiceMtSmartEffectMapping = {
  [EffectChoiceKey.BackgroundBlur]: MTSmartEffect.Blur,
  [EffectChoiceKey.BackgroundSolidColor]: MTSmartEffect.BackgroundColorSwap,
  [EffectChoiceKey.DesignerEffects]: MTSmartEffect.DesignerEffects,
};
